import { Routes } from '@angular/router';
import { authGuard } from './core/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/signin/signin.component').then(
            (m) => m.SigninComponent
          ),
      },
      {
        path: 'signup',
        loadComponent: () =>
          import('./features/auth/signup/signup.component').then(
            (m) => m.SignupComponent
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          ),
      },
      {
        path: 'confirm-mail',
        loadComponent: () =>
          import('./features/auth/confirm-mail/confirm-mail.component').then(
            (m) => m.ConfirmMailComponent
          ),
      },
      {
        path: 'verify-email',// https://localhost:4200/auth/verify-email?token=536c03b25c94ee954c7664cc50c2457s
        loadComponent: () =>
          import('./features/auth/confirm-mail/confirm-mail.component').then(
            (m) => m.ConfirmMailComponent
          ),
      },
    ],
  },
  {
    path: 'dashboard',
    canActivate: [authGuard], // Protect all dashboard routes
    loadComponent: () =>
      import('./layouts/dashboard-layout/dashboard-layout.component').then(
        (m) => m.DashboardLayoutComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/home/home.component').then(
            (m) => m.HomeComponent
          ),
      },
      {
        path: 'analytics',
        loadComponent: () =>
          import('./features/dashboard/analytics/analytics.component').then(
            (m) => m.AnalyticsComponent
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/dashboard/settings/settings.component').then(
            (m) => m.SettingsComponent
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/dashboard/users/users.component').then(
            (m) => m.UsersComponent
          ),
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./features/dashboard/roles/roles.component').then(
            (m) => m.RolesComponent
          ),
      },
      {
        path: 'permissions',
        loadComponent: () =>
          import('./features/dashboard/permissions/permissions.component').then(
            (m) => m.PermissionsComponent
          ),
      },
      {
        path: 'offers',
        loadComponent: () =>
          import('./features/dashboard/offers/offers.component').then(
            (m) => m.OffersComponent
          ),
      },
      {
        path: 'offers/edit',
        loadComponent: () =>
          import('./features/dashboard/offers/edit-offer/edit-offer.component').then(
            (m) => m.EditOfferComponent
          ),
      },
      {
        path: 'automations',
        loadChildren: () =>
          import('./features/dashboard/automations/automations.routes').then(
            (m) => m.AUTOMATION_ROUTES
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./features/dashboard/reports/reports.routes').then(
            (m) => m.REPORTS_ROUTES
          ),
      },
    ],
  },
  {
    path: 'system/settings',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/dashboard/system-settings/system-settings.routes').then(
        (m) => m.SYSTEM_SETTINGS_ROUTES
      ),
  },
  // Error Pages
  {
    path: '404',
    loadComponent: () =>
      import('./features/error-pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
  {
    path: '403',
    loadComponent: () =>
      import('./features/error-pages/forbidden/forbidden.component').then(
        (m) => m.ForbiddenComponent
      ),
  },
  {
    path: '500',
    loadComponent: () =>
      import('./features/error-pages/server-error/server-error.component').then(
        (m) => m.ServerErrorComponent
      ),
  },
  {
    path: 'network-error',
    loadComponent: () =>
      import('./features/error-pages/network-error/network-error.component').then(
        (m) => m.NetworkErrorComponent
      ),
  },
  // Wildcard route - must be last
  {
    path: '**',
    redirectTo: '/404',
  },
];
